<script>
	
	import {API} from '../global.js'
	export let rendicion={}
	export let agrupado=false

	let idrendicion = {}
	let dac = []
	let lineas = []
	let file=false
	let txtFile =''

	$: fetchData = (async() => {
		if(rendicion.IdRendicionDAC>0){
			let url = agrupado ? 'rendiciondet_agrupado' : 'rendiciondet';
			const res = await fetch(`${API}/${url}/${rendicion.IdRendicionDAC}`)
			const data = await res.json()
    		dac = data.data

			//console.log(data[0])
			//console.log(data.length)
			if(res.ok) return data
			else throw new Error(data)
		}
	})

	const presentacion = () => {
		file=true
		lineas = []
		let nro_lote = 0
		let reg_lote = 0
		let comercio= '00000000000000'
		if(rendicion.IdSociedad==4) comercio = '00050013171533'
		if(rendicion.IdSociedad==12) comercio = '00050012928883'

		let importe_lote = 0
		let fecha = rendicion.FechaContable.substr(0,2)+rendicion.FechaContable.substr(3,2)+rendicion.FechaContable.substr(8,2)

		// arma registros detalle
		for(let i=0; i<dac.length; i++){
			dac[i]['rformat'] = '   '+('0000000000000000'+dac[i].numero).trim().substr(-16)+' '+('00000000'+dac[i].idcliente).substr(-8)+
								fecha+'        '+('000000000000000'+(((dac[i].importe.toFixed(2))*100).toFixed(0))).substr(-15)+
								'       '+("0000000000000000"+dac[i].idcliente).substr(-15)+'E'
		}
		let total_reg = dac.length

		// arma registros de cabecera
		for(let i=0; i<parseInt(total_reg)/99; i++){
			let reg = dac.splice(0,99)
			let importe = reg.reduce( (a,b) => (parseFloat(a)+parseFloat(b.importe) ),0)
			lineas.push({lote:i+1, 
					importe:0, 
					cantidad:reg.length, 
					importe: importe , 
					hformat : "0DB"+fecha+"084130"+("0000"+(i+1)).substr(-4)+"       "+comercio+("00"+reg.length).substr(-2)+
								("000000000000000"+((importe.toFixed(2)*100).toFixed(0))).substr(-15)+" 9312                  ",
					reg:reg })
		}

		//genera txt
		lineas.forEach( (linea,li) => {
			txtFile = txtFile+linea.hformat+`\r\n`
			linea.reg.forEach( (reg, ri) => {
				txtFile = txtFile+reg.rformat+`\r\n`
			})
		})

		//save file
		const textToBLOB = new Blob([txtFile], { type: 'text/plain' });
        const sFileName = 'visamov'+rendicion.IdRendicionDAC+'.txt';

        let newLink = document.createElement("a");
        newLink.download = sFileName;

        if (window.webkitURL != null) {
            newLink.href = window.webkitURL.createObjectURL(textToBLOB);
        }
        else {
            newLink.href = window.URL.createObjectURL(textToBLOB);
            newLink.style.display = "none";
            document.body.appendChild(newLink);
        }

        newLink.click(); 

	}

	
</script>


<div>
	{#await fetchData()}
		<p>Loading ....</p>		
		{:then data}
		<p class="sticky inset-0 bg-gray-300 py-3 px-2 m-0">
			Total de Registros {data.length} {agrupado?'(Agrupado)':''}
			<button on:click={presentacion} class="px-3 py-1 bg-white float-right">TXT</button>
		</p>
		<table class="table table-sm table-hover text-sm">
			<thead>
				<tr>
					<td class="px-2 py-1 border font-bold">#</td>
					<td class="px-2 py-1 border font-bold">Cliente</td>
					<td class="px-2 py-1 border font-bold">Nombre</td>
					<td class="px-2 py-1 border font-bold">IdMedioPago</td>
					<td class="px-2 py-1 border font-bold">Tarjeta</td>
					<td class="px-2 py-1 border font-bold">Importe</td>
					<td class="px-2 py-1 border font-bold">_</td>

				</tr>
			</thead>
			<tbody>
				{#each data.data as item, index}
					<tr>
					  <td class="px-2 py-1 border">{index}</td>
					  <td class="px-2 py-1 border">{item.idcliente}</td>
					  <td class="px-2 py-1 border">{item.razonsocial}</td>
					  <td class="px-2 py-1 border">{item.idmediopagocliente}</td>
					  <td class="px-2 py-1 border">***********{item.numero.trim().substr(-5,5)}</td>
					  <td class="px-2 py-1 border text-right">{item.importe.toFixed(2)}</td>
					  <td class="px-2 py-1 border">x{item.idmoneda||''}</td>

					</tr>
				{/each}
			</tbody>
		</table>	
		{:catch error}
			<p>{error}</p>
	{/await}	
</div>

